import React from 'react';
import { Link } from 'react-router-dom';

import { defaultPageWrapper } from '../wrappers/defaultPageWrapper';


export class NotFoundPage extends React.Component {
  componentDidMount() {
    document.body.className = 'dashboard';
  }
  
  render() {
    return (
      <div style={{ color: 'white' }}>
        Oops, this page doesn't exist. <Link to="/">Go home</Link>
      </div>
    );
  }
}

export default defaultPageWrapper(NotFoundPage);


// WEBPACK FOOTER //
// ./src/components/pages/NotFoundPage.jsx